import DataService from './DataService';
import Utils, {param, toTitleCase} from "@shared/utils";


const MetaService = {
  metaData: {},
  prefix: 'api/meta',
  post(url, data, config){
    let urlKey = `post_${url}`;
    if(this.metaData[urlKey]) return this.metaData[urlKey];
    return DataService.post(url, data, config).then(resp => {
      this.metaData[urlKey] = new Promise(resolve => resolve(resp));
      return resp;
    });
  },
  postFormData(url, _data, config){
    let data = _data || {};
    let urlKey = `post_${url}`;
    if(this.metaData[urlKey]) return this.metaData[urlKey];
    const params = param(data);
    return this.post(url, params, {
      headers: {
        'Content-Type' :'application/x-www-form-urlencoded',
      },
      ...config
    }).then(resp => {
      this.metaData[urlKey] = new Promise(resolve => resolve(resp));
      return resp;
    });
  },
  getCountriesData(){
    return new Promise(resolve => {
      this.get('getCountryListPub').then(wholeResponse => {
        if (wholeResponse.statusKey === "SUCCESS") {
          let countries = [], nationalities = [], mobileCodeList = [];
          this.countryList = wholeResponse.data;
          wholeResponse.data.map(v => {
            countries.push({
              label: v.countryName,
              value: v.countryId,
              code: v.countryAlpha3Code
            });
            nationalities.push({
              label: toTitleCase(v.nationality),
              value: v.countryId,
              code: v.countryAlpha3Code
            });
            if(v.countryTelCode){
              mobileCodeList.push({
                label: `+${v.countryTelCode}`,
                value: v.countryTelCode
              });
            }
            // if(v.countryId === DataStore.getData().addBeneData.country.value) this.selectedCountry = v;
          });
          resolve({
            wholeResponse,
            countries,
            nationalities,
            mobileCodeList
          });
        }
      });
    })
  },
  get(url, data, config){
    let urlKey = `get_${url}`;
    if(this.metaData[urlKey]) return this.metaData[urlKey];
    return DataService.get(url, data, config).then(resp => {
      this.metaData[urlKey] = new Promise(resolve => resolve(resp));
      return resp;
    });
  },
  clear(url){
    delete this.metaData[`get_${url}`];
    delete this.metaData[`post_${url}`];
  },
  reset(){
    this.metaData = {};
  }
}

export default MetaService;
